export enum DocumentFormat {
  ARRIVED_HOMES_V1 = 'ARRIVED_HOMES_V1',
  ARRIVED_HOMES_II_V1 = 'ARRIVED_HOMES_II_V1',
  ARRIVED_STR_V1 = 'ARRIVED_STR_V1',
  ARRIVED_HOMES_DUO_V1 = 'ARRIVED_HOMES_DUO_V1',
}
